export * from './family-detail.component';
export * from './family-detail.service';
